import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3a18720"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop__modal__header" }
const _hoisted_2 = {
  class: "heading",
  "data-ts": "heading"
}
const _hoisted_3 = { class: "modal-backdrop__modal__body" }
const _hoisted_4 = { class: "modal-backdrop__modal__footer" }

import { computed, CSSProperties, ref } from 'vue';
import BtnIcon from '../BtnIcon/BtnIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppModal',
  props: {
    showModal: { type: Boolean },
    title: {},
    size: {},
    minimumWidth: {},
    minimumHeight: {}
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const modal = ref(null);

const closeModal = () => {
	emit('closeModal');
};

const computedSizeClass = computed(() => {
	switch (props.size) {
		case 'small':
			return 'modal-backdrop__modal--small';
		case 'large':
			return 'modal-backdrop__modal--large';
		case 'normal':
		default:
			return '';
	}
});
const computedMinWidth = (): CSSProperties => {
	if (props.minimumWidth) {
		return {
			'min-width': `${props.minimumWidth}px`,
		};
	}
	return {};
};
const computedMinHeight = (): CSSProperties => {
	if (props.minimumHeight) {
		return {
			'min-height': `${props.minimumHeight}px`,
		};
	}
	return {};
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      appear: "",
      "enter-active-class": "enter-active",
      "enter-from-class": "enter-from",
      "enter-to-class": "enter-to",
      "leave-active-class": "leave-active",
      "leave-from-class": "leave-from",
      "leave-to-class": "leave-to"
    }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              "data-ts": "modal-backdrop",
              class: "modal-backdrop",
              onClick: _withModifiers(closeModal, ["self"])
            }, [
              _createVNode(_Transition, {
                appear: "",
                "enter-active-class": "enter-active-modal",
                "enter-from-class": "enter-from-modal",
                "enter-to-class": "enter-to-modal",
                "leave-active-class": "leave-active-modal",
                "leave-from-class": "leave-from-modal",
                "leave-to-class": "leave-to-modal"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(['modal-backdrop__modal relative', computedSizeClass.value]),
                    style: _normalizeStyle([computedMinWidth(), computedMinHeight()]),
                    role: "dialog",
                    ref_key: "modal",
                    ref: modal,
                    "aria-modal": "true",
                    "aria-labelledby": "modal"
                  }, [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
                      _createVNode(BtnIcon, {
                        "icon-name": "bx bx-x",
                        ariaLabel: "close modal",
                        "data-ts": "close-btn",
                        onClick: closeModal
                      })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      (_ctx.$slots.body)
                        ? _renderSlot(_ctx.$slots, "body", { key: 0 }, () => [
                            _createTextVNode("modal body")
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      (_ctx.$slots.footer)
                        ? _renderSlot(_ctx.$slots, "footer", { key: 0 }, () => [
                            _createTextVNode("modal footer")
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ], 6), [
                    [_vShow, _ctx.showModal]
                  ])
                ]),
                _: 3
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})